import { createFileRoute } from '@tanstack/react-router';

import { Details } from './-components';

export const Route = createFileRoute('/_staff/public-ids/$id/details/')({
  component: PublicIdDetails,
});

function PublicIdDetails() {
  const { id } = Route.useParams();

  return <Details publicId={id} />;
}
